import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { logOutUser } from 'Auth/redux/auth.redux';
import logoutIcon from 'assets/images/logout-hover.svg';
import Avatar from 'shared/components/Avatar';

import s from './LogOut.pcss';
import { getLocalStorage } from '../../shared/utils/storage';


@connect(
  null,
  { logOutUser },
)
@withRouter
class Index extends PureComponent {
  static propTypes = {
    logOutUser: PropTypes.func.isRequired,
    history: PropTypes.shape().isRequired,
  };

  state = {
    expanded: false,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.onHandleBlur);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onHandleBlur);
  }

  setRef = (ref) => {
    this.logOutContainer = ref;
  };

  onHandleBlur = (e) => {
    if (this.logOutContainer && !this.logOutContainer.contains(e.target)) {
      this.setState({ expanded: false });
    }
  };

  toggleExpand = () => this.setState({ expanded: !this.state.expanded });

  logout = () => {
    this.props.logOutUser();
    this.props.history.push('/login');
  };

  render() {
    const info = getLocalStorage(['abbriviationName', 'email', 'photo']);
    return (
      <div ref={this.setRef}>
        <div className={s.avatarContainer}>
          <Avatar link={info.photo} defaultIcon={logoutIcon} onClick={this.toggleExpand} size={25} />
        </div>
        {this.state.expanded &&
          <div className={s.dropdownContainer}>
            <div className={s.option}>
              <div className={s.name}>{info.abbriviationName}</div>
              <div className={s.email}>{info.email}</div>
            </div>
            <div onClick={this.logout} className={s.logout}>
              <div className={s.option}>
                Выход
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/Root/LogOut/index.js